import React from "react";
import user from "../assets/images/user.png";
import insta from "../assets/icons/insta.svg";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { ThreeDotsIcon } from "../assets/icons/Icons";

const SpecificAccountCard = ({ width, className }: { width?: string; className?: string }) => {
  const redirect = useRedirect();
  return (
    <div onClick={() => redirect(pathnames.accounts+pathnames.specificAccount)} className={`${width ? `w-[${width}]` : "w-[379px]"} h-[99px] bg-white rounded-xl p-3 ${className} cursor-pointer`}>
      <div className="flex items-center gap-[10px]">
        <div className="w-10 h-10 rounded-full relative">
          <img src={user} className="rounded-full" alt="user" />
          <img src={insta} className="w-4 h-4 rounded-full absolute -right-[1px] bottom-1" alt="social icon" />
        </div>
        <div className="w-full">
          <div className="flex justify-between">
            <h1 className="text-[#0F0C18] text-base font-medium tracking-tight">@andrew_wack</h1>
            <ThreeDotsIcon />
          </div>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Martin Frazer</p>
        </div>
      </div>
      <div className="mt-[5px] flex items-center gap-[17px]">
        <div className="w-4 h-4 ml-3" />
        <div className="flex items-center gap-6">
          <div>
            <p className="text-[#9392A2] text-xs font-medium">Followers</p>
            <p className="text-[#0F0C18] text-xs font-medium">15,5k</p>
          </div>
          <div>
            <p className="text-[#9392A2] text-xs font-medium">Posts</p>
            <p className="text-[#0F0C18] text-xs font-medium">35</p>
          </div>
          <div>
            <p className="text-[#9392A2] text-xs font-medium">Language</p>
            <p className="text-[#0F0C18] text-xs font-medium">English</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecificAccountCard;